<!-- DETAILS VIEW -->
@if (view() === 'details') {
  <h2 mat-dialog-title class="meeting-title">{{ meeting.title }}</h2>
  <mat-dialog-content>
    <div class="details-grid">
      <span class="detail-label">Counselor</span>
      <span class="detail-value">{{ meeting.facultyName }}</span>

      <span class="detail-label">Date &amp; Time</span>
      <span class="detail-value date-time-value">
        {{ meeting.start | date: 'EEEE, MMMM d' }} &bull; {{ meeting.start | date: 'h:mm' }}–{{
          meeting.end | date: 'h:mm a'
        }}
      </span>

      <span class="detail-label">Status</span>
      <span class="detail-value">
        <span class="status" [class]="meeting.state">{{ meeting.stateLabel }}</span>
      </span>

      <span class="detail-label">Details</span>
      <span class="detail-value reason-text">{{ meeting.description }}</span>

      @if (counselorInstructions) {
        <span class="detail-label">Instructions</span>
        <span class="detail-value instructions-text" data-testid="meeting-instructions">{{
          counselorInstructions
        }}</span>
      }

      @if (meeting.note) {
        <span class="detail-label">Notes</span>
        <span class="detail-value reason-text note-row">
          <span class="note-preview" data-testid="counselor-note"
            >{{ notePreview }}{{ notePreviewTruncated ? '…' : '' }}</span
          >
          <button
            mat-button
            class="view-note-link"
            type="button"
            data-testid="view-note-btn"
            (click)="goToView('note')"
          >
            View note
          </button>
        </span>
      }

      @if (meeting.proposedStart) {
        <span class="detail-label">Proposed changes</span>
        <span class="detail-value">
          {{ meeting.proposedStart | date: 'EEEE, MMMM d' }} &bull;
          {{ meeting.proposedStart | date: 'h:mm' }}–{{ meeting.proposedEnd | date: 'h:mm a' }}
          @if (meeting.proposedLocation) {
            &bull; {{ meeting.proposedLocation }}
          }
          @if (!isAwaitingMyResponse) {
            <span class="status pending reschedule-chip">Pending approval</span>
          }
          @if (meeting.proposedMessage) {
            <br />
            <span class="reason-text">{{ meeting.proposedMessage }}</span>
          }
        </span>
      }
    </div>
  </mat-dialog-content>
  @if (submitError()) {
    <p class="submit-error" data-testid="submit-error">{{ submitError() }}</p>
  }
  <mat-dialog-actions align="end">
    <button mat-button type="button" data-testid="close-btn" (click)="dialogRef.close()">
      Close
    </button>
    @if (isAwaitingMyResponse) {
      <button
        mat-button
        color="warn"
        data-testid="decline-changes-btn"
        type="button"
        [disabled]="submitting()"
        (click)="declineChanges()"
      >
        Decline
      </button>
      <button
        mat-flat-button
        color="primary"
        data-testid="accept-changes-btn"
        type="button"
        [disabled]="submitting()"
        (click)="acceptChanges()"
      >
        {{ submitting() ? 'Accepting…' : 'Accept changes' }}
      </button>
    }
    @if (meeting.isActive) {
      <button
        mat-flat-button
        class="propose-changes-btn-blue"
        data-testid="propose-changes-btn"
        type="button"
        (click)="openProposeChanges()"
      >
        Propose changes
      </button>
      <button
        mat-flat-button
        class="cancel-btn-red"
        data-testid="cancel-meeting-btn"
        type="button"
        (click)="goToView('cancel')"
      >
        Cancel meeting
      </button>
    }
  </mat-dialog-actions>
}

<!-- CANCEL CONFIRMATION VIEW -->
@if (view() === 'cancel') {
  <h2 mat-dialog-title>Cancel this meeting?</h2>
  <mat-dialog-content>
    <p class="cancel-message">
      Are you sure you want to cancel your <strong>{{ meeting.title }}</strong> meeting with
      <strong>{{ meeting.facultyName }}</strong> on
      <strong>{{ meeting.start | date: 'EEEE, MMMM d' }}</strong
      >?
    </p>
    <p class="cancel-note">You'll need to request a new meeting if you change your mind.</p>
  </mat-dialog-content>
  @if (submitError()) {
    <p class="submit-error" data-testid="submit-error">{{ submitError() }}</p>
  }
  <mat-dialog-actions align="end">
    <button mat-button type="button" data-testid="keep-meeting-btn" (click)="goToView('details')">
      Keep meeting
    </button>
    <button
      mat-flat-button
      color="warn"
      type="button"
      data-testid="confirm-cancel-btn"
      [disabled]="submitting()"
      (click)="submitCancel()"
    >
      {{ submitting() ? 'Cancelling…' : 'Yes, cancel' }}
    </button>
  </mat-dialog-actions>
}

<!-- CANCEL SUCCESS VIEW -->
@if (view() === 'canceled') {
  <h2 mat-dialog-title>Meeting canceled</h2>
  <mat-dialog-content>
    <p class="cancel-message">
      Your <strong>{{ meeting.title }}</strong> meeting with
      <strong>{{ meeting.facultyName }}</strong> on
      <strong>{{ meeting.start | date: 'EEEE, MMMM d' }}</strong> has been canceled.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      mat-flat-button
      color="primary"
      type="button"
      data-testid="cancel-done-btn"
      (click)="finishCancel()"
    >
      Done
    </button>
  </mat-dialog-actions>
}

<!-- FULL NOTE VIEW -->
@if (view() === 'note') {
  <h2 mat-dialog-title>Notes</h2>
  <mat-dialog-content>
    <p class="note-full-text" data-testid="note-full-text">{{ meeting.note }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" data-testid="note-back-btn" (click)="goToView('details')">
      Back
    </button>
  </mat-dialog-actions>
}
